export default __webpack_public_path__ + "static/media/credit-card-logos.2d374346.png";